import React from 'react';

import {OETarget} from '../../../react-oe/oe-target';
import {OEVersion} from '../../../react-oe/oe-version';
import OEIconCodes from '../../../lib/oe-icon-codes';
import OEProtoCapBar from '../oe-proto-cap-bar';
import {OEXRayTargetType, OEXRayTargetsSelector, OEXRayFeatureAccessSelector, OEXRayStartSelectionDataSelector} from './oe-xray-model';

export default class OEXRayCapBar extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = this.determineState();

        //
        this.targetTypeMap = {
            [OEXRayTargetType.xRayArm]:         {icon: OEIconCodes.xRay.xRayArmTarget, label: 'Arm', labelId: 'cap_bar_target_title_x_ray_arm', titleId: 'cap_bar_target_title_x_ray_arm'},
            [OEXRayTargetType.xRayLeg]:         {icon: OEIconCodes.xRay.xRayLegTarget, label: 'Leg', labelId: 'cap_bar_target_title_x_ray_leg', titleId: 'cap_bar_target_title_x_ray_leg'},
            [OEXRayTargetType.xRayTrunk]:       {icon: OEIconCodes.xRay.xRayTrunkTarget, label: 'Trunk', labelId: 'cap_bar_target_title_x_ray_trunk', titleId: 'cap_bar_target_title_x_ray_trunk'},
            [OEXRayTargetType.anatomy]:         {icon: OEIconCodes.xRay.anatomyTarget, label: 'Anatomy', labelId: 'cap_bar_target_title_anatomy', titleId: 'cap_bar_target_title_anatomy'},
            [OETarget.effigosExplorerHelp]:     {target: OETarget.effigosExplorerHelp, icon: OEIconCodes.help, noTargetTypeBarEntry: true, titleId: 'target_menu_effigosExplorerHelp'}
        };
    }

    determineState(props)   {
        props = props || this.props;

        //
        let targetTypes = props.version !== OEVersion.xRayMin ? 
            [
                OEXRayTargetType.xRayArm,
                OEXRayTargetType.xRayLeg,
                OEXRayTargetType.xRayTrunk,
                OEXRayTargetType.anatomy,
                OETarget.effigosExplorerHelp
            ] : [
                OEXRayTargetType.xRayArm,
                OEXRayTargetType.xRayLeg,
                OEXRayTargetType.xRayTrunk,
                OETarget.effigosExplorerHelp
            ];

        //
        return {
            targetTypes:                targetTypes,
            versionTargets:             OEXRayTargetsSelector.get(props.version),
            featureAccess:              OEXRayFeatureAccessSelector.get(props.version),
            startSelectionData:         OEXRayStartSelectionDataSelector.get(props.version),
        };
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.version !== this.props.version)    {
            this.setState(this.determineState(nextProps));
        }
    }

    render()    {
        return (
            <OEProtoCapBar
                {...this.props}
                targetTypeMap={this.targetTypeMap}
                {...this.state}
            />
        );
    }
}